import styled from 'styled-components';
import { getColor, makePercent } from 'core/utils';
import { defeatContainer, padContainer } from '../Container';
import {
	hideScroll,
	resetBtn,
	size,
	align,
} from 'styled-manila';

export const Wrapper = styled.div`
	position: relative;
`;

export const TitleRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 27px;
`;

export const Title = styled.h3`
	margin: 0;
	font-size: 19px;
	line-height: 20px;
	letter-spacing: 0.2px;
	font-weight: 600;

	@media (min-width: 767px) {
		font-size: 25px;
		line-height: 24px;
	}
`;

export const AllLink = styled.a`
	font-size: 16px;
	line-height: 1;
	letter-spacing: 0.2px;
	text-decoration: none;
	color: ${getColor("gray")};
	display: flex;
	align-items: center;

	span {
		margin-right: 5px;
	}
`;

export const Collection = styled.div`
	padding: 16px 0;
`;

export const GiftsWrapper = styled.div`
	overflow: hidden;
	position: relative;
	${defeatContainer};

	&:before, &:after {
		content: '';
		width: 120px;
		height: 100%;
		position: absolute;
		z-index: 2;
		pointer-events: none;
		transition: opacity 0.25s;
		top: 0;

		@media (min-width: 1024px) {
			display: none;
		}
	}

	&:before {
		left: 0;
		background-image: linear-gradient(90deg, rgba(248, 250, 250, 1), rgba(248, 250, 250, 0.01));
		opacity: ${props => props.noScrollYet ? '1': '0'};
	}

	&:after {
		right: 0;
		background-image: linear-gradient(90deg, rgba(248, 250, 250, 0.01), rgba(248, 250, 250, 1));
		opacity: ${props => props.doneScrollingX ? '0': '1'};
	}
`;

export const Gifts = styled.div`
	display: flex;
	margin-left: -8px;
	margin-right: -8px;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	${hideScroll};
	${padContainer};
	padding-bottom: 16px;
`;

export const Gift = styled.a`
	display: flex;
	flex-direction: column;
	text-decoration: none;
	padding: 0 8px;
	width: 260px;
	flex-basis: 260px;
	max-width: 260px;
	min-width: 260px;

	&:hover, &:focus {
		text-decoration: none;
	}

	@media (min-width: 767px) {
		text-align: center;
		width: 314px;
		flex-basis: 314px;
		max-width: 314px;
		min-width: 314px;
	}

	&:last-child {
		position: relative;

		&:after {
			content: '';
			width: 16px;
			height: 100%;
			display: block;
			position: absolute;
			top: 0;
			right: -15px;
		}
	}
`;

export const Name = styled.h5`
	margin: 0;
	font-weight: 600;
	line-height: 17px;
	color: ${getColor("gray")};
	letter-spacing: 0.2px;
`;

export const Frame = styled.div`
	overflow: hidden;
	position: relative;
	padding-top: 100%;
	background-color: ${getColor('gray1')};
	margin-bottom: 16px;

	@media (min-width: 767px) {
		padding-top: 76.5%;
	}
`;

export const Pic = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Next = styled.button`
	${resetBtn};
	${size(50)};
	right: 10px;
	display: none;
	z-index: 3;
	${align('vertical')};
	top: ${props => props.vip ? '32%' : '42%'};
	background: ${getColor('white')};
	border-radius: 50%;
	color: ${getColor('gray8')};
	box-shadow: 0 0 35px 0 rgba(74, 74, 74, 0.2);
	transition: 0.2s;

	&:hover, &:focus {
		color: ${getColor('primaryBrand')};
		box-shadow: 0 0 15px 0 rgba(74, 74, 74, 0.4);
	}

	@media (min-width: 1024px) {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	@media (min-width: 1350px) {
		right: -25px;
	}

	svg {
		transition: 0.2s;
		${size(15)};
	}
`;

export const Prev = styled(Next)`
	right: auto;
	left: 10px;

	@media (min-width: 1350px) {
		left: -25px;
	}

	svg {
		transform: rotate(180deg);
	}
`;
